import {COLORS} from '@/utils/constants';
import {entrepreneursObtainedFundsChartCalculation} from './common/entrepreneurs-obtained-funds-chart-calculation';

const transformData = [
    {
        name: 'Family & friends',
        key: 'question27',
    },
    {
        name: 'Business Angels',
        key: 'question21',
    },
    {
        name: 'Crowdfunding',
        key: 'question25',
    },
    {
        name: 'Incubators and Accelerators',
        key: 'question35',
    },
    {
        name: 'NGO’s loans',
        key: 'question33',
    },
    {
        name: 'NGO’s grants',
        key: 'question37',
    },
    {
        name: 'Public subsidies (e.g. tax credits)',
        key: 'question45',
    },
    {
        name: 'Public grants',
        key: 'question49',
    },
    {
        name: 'Venture capital',
        key: 'question53',
    },
    {
        name: 'Microfinance',
        key: 'question57',
    },
    {
        name: 'Financial institutions (banks)',
        key: 'question61',
    },
    {
        name: 'Other',
        key: 'question65',
    },
];

const series = [
    {
        name: 'Yes',
        value: 'Item 1',
        color: COLORS.green,
    },
    {
        name: 'No',
        value: 'Item 3',
        color: COLORS.gray,
    },
    {
        name: 'Pending',
        value: 'Item 2',
        color: COLORS.orange,
    }
]

/**
 * question: Did you receive the funds?
 * 
 * == baseline
 * question27
 * question21
 * question25
 * question35
 * question33
 * question37
 * question45
 * question49
 * question53
 * question57
 * question61
 * question65
 * 
 * @param props 
 * @returns 
 */
export const entrepreneursBaselineObtainedFundsChartCalculation = (props: any): Highcharts.Options => {
    return entrepreneursObtainedFundsChartCalculation(props.baselineSubmissions, transformData, series);
}